import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => (
  <a
    href="https://wa.me/918882558799"
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-5 right-5 z-50"
  >
    <div className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-xl transition-transform hover:scale-110">
      <MessageCircle className="w-6 h-6" />
    </div>
  </a>
);

export default WhatsAppButton;